__turbopack_context__.v({
  "accordionSlideOverwrite": "registrationCounter-module-scss-module__g99oUa__accordionSlideOverwrite",
  "fadeIn": "registrationCounter-module-scss-module__g99oUa__fadeIn",
  "fadeOut": "registrationCounter-module-scss-module__g99oUa__fadeOut",
  "registrationStats": "registrationCounter-module-scss-module__g99oUa__registrationStats",
  "registrationStatsAvailable": "registrationCounter-module-scss-module__g99oUa__registrationStatsAvailable",
  "scaleIn": "registrationCounter-module-scss-module__g99oUa__scaleIn",
  "scaleOut": "registrationCounter-module-scss-module__g99oUa__scaleOut",
  "zoomIn": "registrationCounter-module-scss-module__g99oUa__zoomIn",
  "zoomOut": "registrationCounter-module-scss-module__g99oUa__zoomOut",
});
